import { Component, ElementRef, OnInit, viewChild, ChangeDetectionStrategy } from '@angular/core';
import { onWindowLoad } from '../../helpers/on-window-load.function';
import { ServiceMenuComponent } from '../service-menu/service-menu.component';
import { LangSelectorComponent } from '../lang-selector/lang-selector.component';
import { TranslatePipe } from '@ngx-translate/core';
import { MANAGER_PHONES, PHONE_NUMBER_MASK, WEBSITE_HOSTNAME } from '../../constants';
import { NgxMaskPipe } from 'ngx-mask';

/** Google's platform.js attaches gapi to window and ships no types of its own. */
interface GapiWindow {
  gapi: {
    load(feature: string, onLoad: () => void): void;
    ratingbadge: { render(el: HTMLElement, options: Record<string, string | number>): void };
  };
}

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ServiceMenuComponent, LangSelectorComponent, TranslatePipe, NgxMaskPipe],
})
export class FooterComponent implements OnInit {

  readonly badgeRef = viewChild<ElementRef>('badgeRef');
  protected readonly WEBSITE_HOSTNAME = WEBSITE_HOSTNAME;

  constructor() { }

  ngOnInit() {
    onWindowLoad(() => this.showRatingBadge());
  }

  private showRatingBadge() {
    const gapiWindow = window as unknown as GapiWindow;
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://apis.google.com/js/platform.js';
    script.setAttribute("async", 'true');
    script.setAttribute("defer", 'true');
    script.onload = () => {
      gapiWindow.gapi.load('ratingbadge', () => {
        gapiWindow.gapi.ratingbadge.render(
          this.badgeRef().nativeElement,
          {
            "merchant_id": 139367975,
            "position": "INLINE"
          }
        );
      });
    };

    document.getElementsByTagName('head')[0].appendChild(script);
  }

  protected readonly MANAGER_PHONES = MANAGER_PHONES;
  protected readonly PHONE_NUMBER_MASK = PHONE_NUMBER_MASK;
}
